export * from './post-durchgang.component';
export * from './post-durchgang.component.module';